import { getCurrentApplicationId } from "~/lib/applicationId";

export type AdjustPlatform =
  | "RenkaAndroid"
  | "HokageIos"
  | "CarinaIos"
  | "SakuraIos";

/** Repro・Adjust イベント送信対象のネイティブアプリ applicationId */
// 84: Sina に変換したアプリ（Sakura）。本家と同様に Repro 送信対象に含める
const NATIVE_APPLICATION_IDS = new Set(["76", "84", "93", "95"]);

export const isNativeApplication = (): boolean => {
  return NATIVE_APPLICATION_IDS.has(getCurrentApplicationId());
};

export const getCurrentAdjustPlatform = (): AdjustPlatform | null => {
  const appId = getCurrentApplicationId();
  switch (appId) {
    case "76":
      return "RenkaAndroid";
    case "93":
      return "HokageIos";
    case "95":
      return "CarinaIos";
    case "84":
      return "SakuraIos";
    default:
      return null;
  }
};
